import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import FLAG_ICONS from '../../constants/flag-icons';
class FlagIcon extends Component {
  static propTypes = {
    className: PropTypes.string,
    svgID: PropTypes.string.isRequired,
  }

  render() {
    const {
      className,
      svgID,
    } = this.props;

    const icon = FLAG_ICONS[svgID];
    if (!icon) {
      console.error(`FlagIcon: ${svgID} icon not found`); // eslint-disable-line no-console
      return null;
    }

    return (
      <img
        className={cx('FlagIcon', className)}
        alt={`Flag of ${icon.name}`}
        title={icon.name}
        src={icon.file} />
    );
  }
}

export default FlagIcon;
